// src/utils/enrollmentUtils.js

export const ONBOARDING_PROGRAM_CODE = 'hemotag_device_onboarding';

const DEFAULT_CALL_RULE = {
  frequency: "weekly",
  interval: 1,
  days: ["monday"],
  days_of_month: [],
  date: "",
  hour: 9,
  minute: 0,
  period: "AM"
};

const ONBOARDING_DEFAULT_CALL_RULE = {
  frequency: "once",
  interval: 1,
  days: [],
  days_of_month: [],
  date: "",
  hour: 9,
  minute: 0,
  period: "AM"
};

const PROGRAM_CONFIGS = {
  [ONBOARDING_PROGRAM_CODE]: {
    hasSymptoms: false,
    requiresDeviceId: true,
    defaultCallRule: ONBOARDING_DEFAULT_CALL_RULE,
  },
  default: {
    hasSymptoms: true,
    requiresDeviceId: false,
    defaultCallRule: DEFAULT_CALL_RULE,
  }
};

export const getProgramConfig = (code) =>
  PROGRAM_CONFIGS[code] || PROGRAM_CONFIGS.default;

export const extractSymptomsFromProgram = (program) => {
  if (!program || program.code === ONBOARDING_PROGRAM_CODE) return [];
  return (program.items_to_ask || []).map(st => ({ code: st.code, name: st.name }));
};

export const buildInitialSymptoms = (symptoms, existingSymptoms = {}) => {
  const initial = {};
  symptoms.forEach(s => {
    initial[s.code] = existingSymptoms[s.code] || false;
  });
  return initial;
};

export const convertRuleToApiFormat = (rule) => {
  let hour24 = parseInt(rule.hour);
  if (rule.period === "PM" && hour24 !== 12) {
    hour24 += 12;
  } else if (rule.period === "AM" && hour24 === 12) {
    hour24 = 0;
  }

  const base = {
    frequency: rule.frequency || 'weekly',
    hour: hour24,
    minute: parseInt(rule.minute),
  };

  switch (base.frequency) {
    case 'once':
      return { ...base, date: rule.date };
    case 'daily':
      return { ...base, interval: rule.interval || 1 };
    case 'weekly':
      return { ...base, interval: rule.interval || 1, days: rule.days || [] };
    case 'monthly':
      return { ...base, interval: rule.interval || 1, days_of_month: rule.days_of_month || [] };
    default:
      return base;
  }
};